module.exports = __webpack_public_path__ + "media/components/assets/sujung_06-0e85824a666532f0095599428d16b2be.png";